export default "__VITE_ASSET__J_bQt8KS__"